import { resolveMetricDisplayName } from "@/utils/formatting/format-metric-display-results"

import type { RunResultsMetricRenderAdaptersById } from "../types"

const graphemeSegmenter = new Intl.Segmenter(undefined, {
  granularity: "grapheme",
})

/**
 * Display label for a metric column. In compact mode, abbreviates to initials
 * (multi-word) or truncates a long single word; otherwise shows the full name.
 */
export function getMetricDisplayLabel(
  metricKey: string,
  isCompact: boolean,
  metricRenderAdaptersById: RunResultsMetricRenderAdaptersById,
): string {
  const fullName = resolveMetricDisplayName(
    metricRenderAdaptersById[metricKey]?.metric_display_name,
    metricKey,
  )

  if (!isCompact) {
    return fullName
  }

  const words = fullName.split(/[\s_-]+/)
  if (words.length > 1) {
    return words
      .map(
        (word) =>
          graphemeSegmenter.segment(word)[Symbol.iterator]().next().value
            ?.segment ?? "",
      )
      .join("")
      .toUpperCase()
  }

  const graphemes = Array.from(
    graphemeSegmenter.segment(fullName),
    ({ segment }) => segment,
  )
  if (graphemes.length > 8) {
    return `${graphemes.slice(0, 6).join("")}...`
  }

  return fullName
}
